import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { QualificationsDto } from './qualifications.dto';


export class AllQualificationsResponse extends GlobalResponseObject{
    data?: QualificationsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: QualificationsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}